import React from 'react'
import './section-title.css'
import classnames from 'classnames'

const SectionTitle = ({border, children, ...props}) => {
    const classes = classnames('section-title', {'has-border': border});

    return(
        <div {...props} className={`section-title ${props.className}`}>
            <h4 className="text-uppercase text-bold">{children}</h4>
        </div>
    )
};

export default SectionTitle;


// WEBPACK FOOTER //
// ./src/components/common/section-title/index.jsx